// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedArtevoAddOnError_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M24 18.75C24 21.6495 21.6495 24 18.75 24C15.8505 24 13.5 21.6495 13.5 18.75C13.5 15.8505 15.8505 13.5 18.75 13.5C21.6495 13.5 24 15.8505 24 18.75Z" class="svg-fg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.75 24C21.6495 24 24 21.6495 24 18.75C24 15.8505 21.6495 13.5 18.75 13.5C15.8505 13.5 13.5 15.8505 13.5 18.75C13.5 21.6495 15.8505 24 18.75 24ZM16.875 15.75L15.75 16.875L17.625 18.75L15.75 20.625L16.875 21.75L18.75 19.875L20.625 21.75L21.75 20.625L19.875 18.75L21.75 16.875L20.625 15.75L18.75 17.625L16.875 15.75Z" fill="#ED5353"/>
  <path d="M0 0H2V2H20V0H22V4H12V5H16V12.0397C15.2651 12.3412 14.5907 12.76 14 13.2726V7H8V19.7639C7.46924 19.2889 6.76835 19 6 19V5H10V4H0V0ZM11.6073 20H8.23607C8.71112 20.5307 8.99999 21.2316 9 22H12.2675C11.9556 21.379 11.7302 20.7071 11.6073 20ZM7.99992 22C7.99992 23.1046 7.10449 24 5.99992 24 4.89535 24 3.99992 23.1046 3.99992 22 3.99992 20.8954 4.89535 20 5.99992 20 7.10449 20 7.99992 20.8954 7.99992 22Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedArtevoAddOnError is a generated icon component.
 */
let IconMedArtevoAddOnError = IconMedArtevoAddOnError_1 = class IconMedArtevoAddOnError extends IconBaseElement {
    render() {
        return html `${IconMedArtevoAddOnError_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedArtevoAddOnError.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedArtevoAddOnError = IconMedArtevoAddOnError_1 = __decorate([
    customElement('zui-icon-med-artevo-add-on-error')
], IconMedArtevoAddOnError);
export { IconMedArtevoAddOnError };
